export default "__VITE_ASSET__CrE09VZ4__"